import React from "react";
import { ElementsViewer } from "@wuilt/section-preview";
import { migrateElement } from "./form-migrations";
import useElements from "../hooks/useElements";
function Form(props) {
  const wuiltContext = useElements();
  const element = migrateElement(props?.value?.id || props?.value?.form_data?.id, props.value);
  return /*#__PURE__*/React.createElement(ElementsViewer.Form, {
    element: element,
    wuiltContext: wuiltContext,
    text: element.settings.texts,
    sectionId: props?.sectionId,
    sectionValueId: element?.id,
    customClassNames: {
      fieldContainerClass: props?.fieldContainerClass,
      textClass: props?.textClass,
      textareaClass: props?.textareaClass,
      actionContainerClass: props?.actionContainerClass,
      buttonClass: props?.buttonClass,
      fileUploadClass: props?.fileUploadClass,
      timeClass: props?.timeClass,
      selectBoxClass: props?.selectBoxClass,
      radioClass: props?.radioClass,
      dateClass: props?.dateClass
    }
  });
}
export default Form;
//# sourceMappingURL=Form.js.map